/* eslint-disable @typescript-eslint/naming-convention */
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private clientFriendlyErrors: { [key: string]: string } = {
    'errors.noConnection': 'errors.details.noConnection',
    'errors.serverBadRequest': 'errors.details.serverBadRequest',
    'errors.serverInternalError': 'errors.details.serverInternalError',
    'errors.serverError': 'errors.details.unexpectedError',
    'errors.unexpectedError': 'errors.details.unexpectedError',
  };

  constructor(private translationService: TranslocoService) {}

  getErrorMessage(error: Error): string {
    if (error instanceof HttpErrorResponse) {
      const errorStatus = error.status.toString();
      if (errorStatus.startsWith('4')) {
        return 'errors.serverBadRequest';
      } else if (errorStatus.startsWith('5')) {
        return 'errors.serverInternalError';
      } else {
        return 'errors.serverError';
      }
    }
    if (!navigator.onLine) {
      return 'errors.noConnection';
    }
    return 'errors.unexpectedError';
  }

  getFriendlyDetails(error: Error): string {
    const message = this.getErrorMessage(error);
    if (Object.keys(this.clientFriendlyErrors).includes(message)) {
      return this.clientFriendlyErrors[message];
    } else {
      return this.clientFriendlyErrors['errors.unexpectedError'];
    }
  }

  getErrorStack(error: Error): string {
    return `${error.message} ${error.stack}` ?? '';
  }

  getErrorLocation(stack: string): any {
    const segments = stack?.split('at ') || [];
    return segments.length > 0
      ? {
          filePath: segments[1],
        }
      : {
          filePath: '',
          lineNumber: 0,
          functionName: '',
        };
  }
}
